<script setup lang="ts">
import '@/assets/scss/form.scss'
import { useToast } from 'primevue/usetoast'
import { computed, onMounted, ref, toRaw, watch } from 'vue'
import { uuid } from 'vue3-uuid'
import moment from 'moment'
import AccountPicker from '@/onenetwork/components/account_picker/AccountPicker.vue'
import { Icon } from '@iconify/vue'
import './../assets/scss/contract.scss'
import TimeLinePicker from '@/onenetwork/components/timeline_picker/TimeLinePicker.vue'
import { yupResolver } from '@primevue/forms/resolvers/yup'
import * as yup from 'yup'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { CONTRACT_API } from '@/modules/contract/constants/contract.api.uri.const.ts'
import BrokerCard from '@/onenetwork/components/account_card/BrokerCard.vue'
import CustomerCard from '@/onenetwork/components/account_card/CustomerCard.vue'
import { useRouter } from 'vue-router'
import { useForm } from 'vee-validate'
import CsFormControl from '@/onenetwork/components/form/CsFormControl.vue'
import AttachmentList from '@/onenetwork/components/attachment_list/AttachmentList.vue'
import { CONTRACT_STATES } from '@/modules/contract/constants/contract.constant.ts'
import { useContractDetailStore } from '@/modules/contract/stores/contract.detail.store.ts'

interface Props {
  listingId: number | null
  contractId: number | null
  action: string | null
}

const props = defineProps<Props>()
const router = useRouter()
const toast = useToast()
const formRef = ref<HTMLFormElement | null>(null)
const contractDetailStore = useContractDetailStore()
const canCreate = ref<boolean>(true)
const listingHasContract = ref<boolean>(false)
const existContract = ref({})

const emit = defineEmits(['on:created'])

const handleCheckContractByListing = async () => {
  if(props.listingId){
    const res = await APIClient.get(CONTRACT_API+'/contract-by-listing/'+props.listingId)

    if(res.data?.data?.data?.length > 0){
      existContract.value = res.data.data.data[0]
      listingHasContract.value = true
    }else{
      listingHasContract.value = false
    }
  } else{
    listingHasContract.value = false
  }
}


const sell_commission = ref('')
const buy_commission = ref('')
const attachmentList = ref([])
const attachmentRemoveList = ref([])
const sell_broker_id = ref(null)
const sell_customer_id = ref(null)
const buy_broker_id = ref(null)
const buy_customer_id = ref(null)
const sell_customer = ref(null)
const sell_broker = ref(null)
const buy_customer = ref(null)
const buy_broker = ref(null)

const contractTypeDataset = [
  { name: 'Hợp đồng ký gửi độc quyền', code: 'HDKGDQ' },
  { name: 'Hợp đồng ký gửi chính chủ', code: 'HDKGCC' }
]

const timelineDataSet = ref<any>([])
const timelineValue = ref('')
const handleTimelineChange = (item: any, dataSet: any) => {

  timelineValue.value = item.id
  timelineDataSet.value = dataSet
}

const handleUpdateAttachment = (data: any) => {
  attachmentList.value = data.attachmentIds
  attachmentRemoveList.value = data.removeIds

}

const handleSelectSellBroker = async (data: any) => {
  if(data && data[0]){
    sell_broker.value = data[0]
    sell_broker_id.value = data[0].id
  }
}
const handleSelectSellCustomer = async (data: any) =>{
  if(data && data[0]){
    sell_customer.value = data[0]
    sell_customer_id.value = data[0].id
  }
}

const handleSelectBuyBroker = async (data: any) => {
  if(data && data[0]){
    buy_broker.value = data[0]
    buy_broker_id.value = data[0].id
  }
}
const handleSelectBuyCustomer = async (data: any) =>{
  if(data && data[0]){
    buy_customer.value = data[0]
    buy_customer_id.value = data[0].id
  }
}

const contractData = ref<any>({
    type: "HDKGDQ",
    code: "",
    title: "",
    sub_title: "",
    signing_date: "",
    execution_date: "",
    progress_state: "",
    commission: "",
    company_commission: "",
    system_commission: "",
    sell_commission: "",
    buy_commission: ""
})
const formErrors = ref(null)
const submiting = ref<boolean>(false)

const resolver = ({ values }) => {
  const errors = {};
  return {
    values, // (Optional) Used to pass current form values to submit event.
    errors
  };
};

const onFormSubmit = async (
  { values, valid }: { values: Record<string, any>; valid: boolean }
) => {
  submiting.value = true
  const formData: any = {
    ...values,
    buy_commission: buy_commission.value,
    sell_commission: sell_commission.value,
    attachments: toRaw(attachmentList.value).map((item: any) => item.uuid),
    attachment_remove_ids: toRaw(attachmentRemoveList.value),
    seller_id: sell_customer_id.value,
    seller_broker_id: sell_broker_id.value,
    status: timelineValue.value,
    // listing_id: props.listingId || ''
  }
  try{
    if(props.action == 'update'){
      const res = await APIClient.post(CONTRACT_API+'/'+props.contractId, {...formData, _method: 'PUT'})
      console.log(res)
      toast.add({ severity: 'success', summary: 'Update hợp đồng thành công', detail: "Thành công", life: 5000});
    }else{
      formData.listing_id = props.listingId || ''
      const res = await APIClient.post(CONTRACT_API, formData)

      toast.add({ severity: 'success', summary: 'Đăng ký hợp đồng thành công', detail: "Thành công", life: 5000});
      if(!props.listingId){
        setTimeout(() =>{
          router.push({name: 'contracts-list'})
        })
      } else{
        emit('on:created', res.data.data)
      }
    }
  } catch (e: any) {

    toast.add({ severity: 'error', summary: 'Đăng ký hợp đồng thất bại', detail: "Xảy ra lỗi khi đăng ký hợp đồng", life: 5000});
    parseErrors(e)
  } finally {
    submiting.value = false
  }
}

const parseErrors = (e: any) => {

  if(e.response?.data?.errors){
    const _errors: any = {}
    Object.values(e.response?.data?.errors).forEach(({field, error} : any) => {

      if(!_errors[field]) {
        _errors[field] = [error];
      } else {
        _errors[field] = [..._errors[field], error]
      }
    })
    formErrors.value = _errors
  }
}

const setTimeLineData = (data: any) => {
  const _dataSet = timelineDataSet.value
  if( _dataSet && _dataSet.length > 0 ){
    let done = false;
    _dataSet.forEach((_item: any) => {
      if(!done){
        if(_item.id == data.status){
          done = true;
          _item.done = true;
        }else{
          _item.done = true;
        }
      } else{
        _item.done = false;
      }
    })
  }

  timelineDataSet.value = _dataSet
}

const contractDetail = computed(() => {
  return contractDetailStore.contracts[props.contractId] || null
})

const fetchDetail = async () => {
  if(props.contractId) {
    try {
      const data = await contractDetailStore.fetchDetail(props.contractId)

      setTimeLineData(data)
    } catch (e: any) {
      console.error(e)
      toast.add({ severity: 'error', summary: 'Lỗi!', detail: "Lỗi khi tải thông tin" })
    }
  }
}

watch([contractDetail.value], () => {

  const contract = contractDetail.value?.contract
  contractData.value = {
    type: contract?.type || "",
    code: contract?.code || "",
    title: contract?.title || "",
    sub_title: contract?.subtitle || "",
    signing_date: moment(contract?.signing_date).toDate() || new Date(),
    execution_date: moment(contract?.liquidated_at).toDate() || new Date(),
    progress_state: contract?.status || "",
    commission: contract?.commission_percent *100 || "",
    sell_commission: contract?.seller_broker_percent *100 || "",
    buy_commission: contract?.buyer_broker_percent *100 || "",
  }
  attachmentList.value = contract?.attachments || []
  buy_commission.value = (contract?.buyer_broker_percent *100).toString() || ""
  sell_commission.value = (contract?.seller_broker_percent *100).toString() || ""
  buy_customer.value = contract?.buyer || null
  buy_customer_id.value = contract?.buyer_id || null
  buy_broker.value = contract?.buyer_broker || null
  buy_broker.value = contract?.buyer_broker_id || null
  sell_customer.value = contract?.seller || null
  sell_customer_id.value = contract?.seller_id || null
  sell_broker.value = contract?.seller_broker || null
  sell_broker_id.value = contract?.seller_broker_id || null

}, {immediate: true})

watch([sell_commission], ()=>{

  if(parseInt(sell_commission.value) > 0 && parseInt(sell_commission.value) < 80){
    buy_commission.value = (80 - parseInt(sell_commission.value)).toString()
  }else{
    sell_commission.value = '1'
    buy_commission.value = '79'
  }

})
watch([buy_commission], ()=>{

  if(parseInt(buy_commission.value) > 0 && parseInt(buy_commission.value) < 80){
    sell_commission.value = (80 - parseInt(buy_commission.value)).toString()
  }else{
    buy_commission.value = '1'
    sell_commission.value = '79'
  }
})

onMounted(() => {
  handleCheckContractByListing()
  if(!contractDetail.value) fetchDetail()

  timelineDataSet.value = CONTRACT_STATES.map((state: any) => ({...state, done: false}))
})

</script>

<template>
<!--  {{contractDetail}}-->
  <template v-if="listingHasContract">
    <Message severity="error" class="w-full mt-5 mb-5" closable>
      <template #icon><Icon icon="fluent:warning-32-filled" height="32px" /></template>
      <div class="ml-2" v-html="`<strong>Chú ý: </strong> Tin bất động sản này hiện tại đã được liên kết với hợp đồng <strong>${existContract.code}</strong>, nếu tiếp tục tạo mới, hợp đồng cũ sẽ bị vô hiệu và thay bằng hợp đồng mới này.`"/>
    </Message>
  </template>
  <template v-if="canCreate">
  <Form
    v-slot="$form"
    ref="formRef"
    :initial-values="contractData"
    :resolver="resolver"
    @submit="onFormSubmit"
    class="py-3 flex flex-col gap-5">

    <table class="detail-table">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Loại hợp đồng</th>
        <td colspan="3">
          <div class="flex-1 font-bold uppercase">
            <Select
              name="type"
              :options="contractTypeDataset"
              optionLabel="name"
              optionValue="code"
              placeholder="Chọn loại hợp đồng"
              class="form-control"
            />
          </div>
        </td>
      </tr>

      <tr>
        <th class="text-right w-[150px]">Mã hợp đồng</th>
        <td colspan="3">
          <cs-form-control name="code" :errors="formErrors" :form="$form">
            <InputText name="code" class="form-control"/>
          </cs-form-control>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Tiêu đề hợp đồng</th>
        <td colspan="3">

          <cs-form-control name="title" :errors="formErrors" :form="$form" class="mb-3">
            <InputText name="title" class="form-control"/>
          </cs-form-control>
          <cs-form-control name="sub_title" :errors="formErrors" :form="$form">
            <InputText name="sub_title" class="form-control"/>
          </cs-form-control>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Đính kèm</th>
        <td colspan="3">
          <attachment-list :data="attachmentList" :editable="true" @update="handleUpdateAttachment" />
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Ngày ký</th>
        <td>

          <cs-form-control name="signing_date" :errors="formErrors" :form="$form">
            <DatePicker
              class="form-control"
              :manual-input="false"
              name="signing_date"
            />
          </cs-form-control>
        </td>
        <th class="text-right w-[150px]">Ngày thanh lý</th>
        <td>
          <cs-form-control name="execution_date" :errors="formErrors" :form="$form">
          <DatePicker
            class="form-control"
            :manual-input="false"
            name="execution_date"
          />
          </cs-form-control>
        </td>
      </tr>
      <tr>
        <th class="text-right w-[150px]">Tiến độ hợp đồng</th>
        <td colspan="3">
          <time-line-picker
            :dataSet="timelineDataSet"
            :value="timelineValue"
            :editable="true"
            @update="handleTimelineChange"/>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="detail-table">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Chính chủ</th>
        <td>
          <cs-form-control name="seller_id" :errors="formErrors" :form="$form">
            <account-picker :account="sell_customer" type="customer" @update:selected="handleSelectSellCustomer"/>
            <template v-if="sell_customer_id">
              <div class="mt-3">
                <customer-card :id="sell_customer_id" :detail="true"/>
              </div>
            </template>
          </cs-form-control>
        </td>
        <th class="text-right w-[150px]">Môi giới bán</th>
        <td>
          <cs-form-control name="seller_broker_id" :errors="formErrors" :form="$form">
            <account-picker :account="sell_broker" type="broker" @update:selected="handleSelectSellBroker"/>
            <template v-if="sell_broker_id">
              <div class="mt-3">
                <broker-card :id="sell_broker_id" :detail="true"/>
              </div>
            </template>
          </cs-form-control>
        </td>
      </tr>
      <tr v-if="props.action == 'update'">
        <th class="text-right w-[150px]">Khách mua</th>
        <td>
          <cs-form-control name="seller_id" :errors="formErrors" :form="$form">
            <account-picker :account="buy_customer" type="customer" @update:selected="handleSelectBuyCustomer"/>

            <template v-if="buy_customer_id">
              <div class="mt-3">
                <customer-card :id="buy_customer_id" :detail="true"/>
              </div>
            </template>
          </cs-form-control>
        </td>
        <th class="text-right w-[150px]">Môi giới mua</th>
        <td>
          <cs-form-control name="seller_broker_id" :errors="formErrors" :form="$form">
            <account-picker :account="buy_broker" type="broker" @update:selected="handleSelectBuyBroker"/>
            <template v-if="buy_broker_id">
              <div class="mt-3">
                <broker-card :id="buy_broker_id" :detail="true"/>
              </div>
            </template>
          </cs-form-control>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="detail-table">
      <tbody>
      <tr>
        <th class="text-right w-[150px]">Hoa hồng môi giới (%)</th>
        <td>
          <cs-form-control name="commission" :errors="formErrors" :form="$form">
            <InputText name="commission" type="number" class="form-control" placeholder="n"/>
          </cs-form-control>
          <Divider/>
          <div class="flex flex-col md:flex-row w-full">
            <div class="flex flex-1 flex-col">
              <div>Hoa hồng công ty (%)</div>
              <div>
                <cs-form-control name="company_commission" :errors="formErrors" :form="$form">
                  <InputText name="company_commission" type="number" class="form-control" placeholder="x" value="12" readonly/>
                </cs-form-control>
              </div>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <div>Hoa hồng các cấp QL & HT (%)</div>
              <div>
                <cs-form-control name="system_commission" :errors="formErrors" :form="$form">
                  <InputText name="system_commission" type="number" class="form-control" placeholder="y" value="8" readonly/>
                </cs-form-control>
              </div>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <div>Hoa hồng môi giới bán (%)</div>
              <div>
                <cs-form-control name="sell_commission" :errors="formErrors" :form="$form">
                  <InputText v-model="sell_commission" min="1" max="79" name="sell_commission" type="number" class="form-control" placeholder="y"/>
                </cs-form-control>
              </div>
            </div>
            <Divider layout="vertical"/>
            <div class="flex flex-1 flex-col">
              <div>Hoa hồng môi giới mua (%)</div>
              <div>
                <cs-form-control name="buy_commission" :errors="formErrors" :form="$form">
                  <InputText v-model="buy_commission" min="1" max="79" name="buy_commission" type="number" class="form-control" placeholder="z"/>
                </cs-form-control>
              </div>
            </div>
          </div>

        </td>
      </tr>
      </tbody>
    </table>
    <Divider/>
    <div class="flex justify-end gap-2">
      <button :disabled="submiting" type="submit" class="btn btn-success flex items-center gap-2"><Icon icon="line-md:check-all" height="1.25rem" />
        <template v-if="submiting">
          Đang cập nhật...
        </template>
        <template v-else>
          Lưu cập nhật
        </template>
      </button>
      <button :disabled="submiting" type="reset" class="btn btn-secondary flex items-center gap-2"><Icon icon="material-symbols:close" height="1.25rem" /> Huỷ cập nhật</button>
    </div>
  </Form>
  </template>
</template>
